/*
 * Naturepride — pagina categoria
 * Filtri Search & Discovery senza ricaricare la pagina (Section Rendering API),
 * ordinamento, "Carica altri", pannello filtri mobile, descrizione accorciata.
 */
(function () {
  'use strict';

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var controller = null;
  var timer = null;
  var lastHref = null;

  function sectionUrl(href, sectionId) {
    var u = new URL(href, location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function cleanUrl(href) {
    var u = new URL(href, location.origin);
    u.searchParams.delete('section_id');
    u.searchParams.delete('page');
    return u.pathname + (u.search ? u.search : '');
  }

  function formUrl(root) {
    var form = $('[data-np-filter-form]', root);
    var params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
    }
    var sort = $('[data-np-sort]', root);
    if (sort) params.set('sort_by', sort.value);
    var q = params.toString();
    return root.getAttribute('data-url') + (q ? '?' + q : '');
  }

  /* ------------------------------------------------------------ render */

  function render(root, href, push) {
    var id = root.getAttribute('data-section');
    var plp = $('.np-plp', root);
    if (!plp) { location.href = href; return; }
    if (push !== false && href === lastHref) return;
    lastHref = href;

    if (controller) controller.abort();
    controller = 'AbortController' in window ? new AbortController() : null;
    plp.classList.add('is-loading');

    /* stato da preservare */
    var openKeys = {};
    $$('.np-fgroup[data-key]', root).forEach(function (d) { openKeys[d.getAttribute('data-key')] = d.open; });
    var expanded = $$('.np-fopts.is-expanded', root).map(function (el) { return el.closest('.np-fgroup').getAttribute('data-key'); });
    var panel = $('[data-np-filters-panel]', root);
    var panelOpen = panel && panel.classList.contains('is-open');
    var panelScroll = panel ? panel.scrollTop : 0;
    var focusId = document.activeElement && document.activeElement.id;

    fetch(sectionUrl(href, id), controller ? { signal: controller.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.np-plp');
        if (!fresh) throw new Error('no plp');
        plp.replaceWith(fresh);

        $$('.np-fgroup[data-key]', root).forEach(function (d) {
          var k = d.getAttribute('data-key');
          if (k in openKeys) d.open = openKeys[k];
          if (expanded.indexOf(k) !== -1) {
            var opts = $('.np-fopts', d);
            var btn = $('[data-np-fmore]', d);
            if (opts) opts.classList.add('is-expanded');
            if (btn) btn.textContent = btn.getAttribute('data-less');
          }
        });
        var newPanel = $('[data-np-filters-panel]', root);
        if (newPanel && panelOpen) {
          setPanel(root, true, true);
          newPanel.scrollTop = panelScroll;
        }
        if (focusId) {
          var f = document.getElementById(focusId);
          if (f) f.focus({ preventScroll: true });
        }
        if (push !== false) history.pushState({ np: true }, '', cleanUrl(href));
        if (!panelOpen && push !== false) {
          var top = root.querySelector('.np-plp').getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--np-header-h'), 10) || 0) - 20;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        lastHref = null;
        location.href = href;
      });
  }

  function loadMore(root, link) {
    var id = root.getAttribute('data-section');
    link.classList.add('is-busy');
    fetch(sectionUrl(link.href, id))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-np-grid]', root);
        var newGrid = doc.querySelector('[data-np-grid]');
        var more = $('[data-np-more-wrap]', root);
        var newMore = doc.querySelector('[data-np-more-wrap]');
        if (!grid || !newGrid) throw new Error('no grid');
        var first = null;
        $$(':scope > li', newGrid).forEach(function (li) {
          if (li.classList.contains('np-empty')) return;
          grid.appendChild(li);
          if (!first) first = li;
        });
        if (more && newMore) {
          var prev = $('.np-more__prev', newMore);
          if (prev) prev.remove();
          more.innerHTML = newMore.innerHTML;
        }
        if (first) {
          var a = first.querySelector('a');
          if (a) a.focus({ preventScroll: true });
        }
      })
      .catch(function () { location.href = link.href; });
  }

  /* ------------------------------------------------------------ pannello mobile */

  function setPanel(root, open, instant) {
    var panel = $('[data-np-filters-panel]', root);
    var scrim = $('.np-filters-scrim', root);
    var btn = $('[data-np-filters-open]', root);
    if (!panel) return;
    if (instant) panel.style.transition = 'none';
    panel.classList.toggle('is-open', open);
    if (scrim) scrim.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (instant) { panel.offsetHeight; panel.style.transition = ''; }
    if (open && !instant) {
      var x = panel.querySelector('.np-filters__x');
      if (x) x.focus();
    }
    if (!open && btn && !instant) btn.focus();
  }

  /* ------------------------------------------------------------ eventi */

  document.addEventListener('change', function (e) {
    var root = e.target.closest('[data-np-collection]');
    if (!root) return;
    if (e.target.matches('[data-np-sort]')) {
      var hidden = $('[data-np-sort-hidden]', root);
      if (hidden) hidden.value = e.target.value;
      render(root, formUrl(root));
      return;
    }
    /* i campi prezzo sono gestiti dall'evento input (con attesa) e dall'invio con Invio */
    if (e.target.closest('[data-np-filter-form]') && !e.target.matches('[data-np-price]')) {
      clearTimeout(timer);
      render(root, formUrl(root));
    }
  });

  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-np-price]')) return;
    var root = e.target.closest('[data-np-collection]');
    clearTimeout(timer);
    timer = setTimeout(function () { render(root, formUrl(root)); }, 800);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-np-filter-form]');
    if (!form) return;
    e.preventDefault();
    var root = form.closest('[data-np-collection]');
    render(root, formUrl(root));
  });

  document.addEventListener('click', function (e) {
    var root = e.target.closest('[data-np-collection]');
    if (!root) return;

    var link = e.target.closest('a[data-np-filter-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      render(root, link.href);
      return;
    }

    var more = e.target.closest('a[data-np-more]');
    if (more && !e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      loadMore(root, more);
      return;
    }

    var fmore = e.target.closest('[data-np-fmore]');
    if (fmore) {
      var opts = $('.np-fopts', fmore.closest('.np-fgroup'));
      var on = !opts.classList.contains('is-expanded');
      opts.classList.toggle('is-expanded', on);
      fmore.textContent = fmore.getAttribute(on ? 'data-less' : 'data-more');
      return;
    }

    if (e.target.closest('[data-np-filters-open]')) { setPanel(root, true); return; }
    if (e.target.closest('[data-np-filters-close]')) { setPanel(root, false); return; }

    var toggle = e.target.closest('[data-np-desc-toggle]');
    if (toggle) {
      var desc = toggle.closest('[data-np-desc]');
      var clamped = desc.classList.toggle('is-clamped');
      toggle.textContent = clamped ? toggle.getAttribute('data-more') : toggle.getAttribute('data-less');
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('[data-np-filters-panel].is-open').forEach(function (p) { setPanel(p.closest('[data-np-collection]'), false); });
  });

  window.addEventListener('popstate', function () {
    var root = $('[data-np-collection]');
    if (root) render(root, location.href, false);
  });

  /* ------------------------------------------------------------ descrizione */

  function initDesc() {
    $$('[data-np-desc]').forEach(function (desc) {
      var text = $('.np-cat-desc__text', desc);
      var btn = $('[data-np-desc-toggle]', desc);
      if (!text || !btn) return;
      var full = text.scrollHeight;
      desc.classList.add('is-clamped');
      if (text.scrollHeight > text.clientHeight + 4 || full > text.clientHeight + 4) {
        btn.setAttribute('data-more', btn.textContent);
        btn.setAttribute('data-less', 'Show less');
        btn.hidden = false;
      } else {
        desc.classList.remove('is-clamped');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initDesc);
  else initDesc();
})();
